import { useEffect } from 'react'

import { breakpoints } from './useMediaQuery'

const useRem = () => {
  useEffect(() => {
    const setRemBase = () => {
      let baseSize = 16
      const clientWidth = document.documentElement.clientWidth

      if (clientWidth > breakpoints.lg && clientWidth <= breakpoints.xl) {
        baseSize = 12
      }
      if (
        clientWidth > breakpoints['xl'] &&
        clientWidth <= breakpoints['2xl']
      ) {
        baseSize = 14
      }

      document.documentElement.style.fontSize = `${baseSize}px`
    }
    setRemBase()
    window.addEventListener('resize', setRemBase)
    return () => window.removeEventListener('resize', setRemBase)
  }, [])
}

export default useRem
